<template>
  <div style="margin-bottom: 20px;">
    <Card shadow>
      <Form :label-width="100">
        <Row :gutter="16">
          <Col span="4">
            <FormItem label="代理">
              <Select v-model="app_id" placeholder="选择代理">
                <Option
                  v-for="(item, index) in app_list.filter(
                    item => item.platform == getinitPlatId()
                  )"
                  :value="item.appid"
                  :label="item.appName"
                  :key="index"
                >
                  {{ item.appName
                  }}<span style="color: #bbb">({{ item.appid }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="4">
            <FormItem label="玩家ID">
              <Input
                v-model="formData.user_id"
                placeholder="请输入玩家ID"
              ></Input>
            </FormItem>
          </Col>
          <Col span="4">
            <FormItem label="操作金额">
              <Input
                v-model="formData.point"
                placeholder="请输入操作金额"
              ></Input>
            </FormItem>
          </Col>
          <Col span="4">
            <FormItem label="充值备注类型">
              <Input
                v-model="formData.reason"
                placeholder="充值备注类型"
              ></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <Button type="primary" style="margin-right:10px" @click="givePay"
              >确认</Button
            >
            <Button
              style="margin-right:10px"
              type="warning"
              @click="moreModal.show = true"
              >批量操作</Button
            >
          </Col>
        </Row>
      </Form>
    </Card>

    <Modal v-model="moreModal.show" width="850">
      <p slot="header" style="color:#1c2438">
        <span>批量赠送</span>
      </p>
      <Form :label-width="140">
        <Row>
          <Col span="22">
            <FormItem label="代理">
              <Select v-model="app_id" placeholder="选择代理">
                <Option
                  v-for="(item, index) in app_list.filter(
                    item => item.platform == getinitPlatId()
                  )"
                  :value="item.appid"
                  :label="item.appName"
                  :key="index"
                >
                  {{ item.appName
                  }}<span style="color: #bbb">({{ item.appid }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="22">
            <FormItem label="金额">
              <Input number v-model="moreModal.form.point"></Input>
            </FormItem>
          </Col>
          <Col span="22">
            <FormItem label="充值备注类型">
              <Input v-model="moreModal.form.reason"></Input>
            </FormItem>
          </Col>
          <Col span="22">
            <FormItem label="手动输入">
              <Input
                type="textarea"
                v-model="moreModal.form.lines"
                :rows="8"
                placeholder="格式:
id
1513011
1231222
注意: 多个使用回车键隔开"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button style="margin-right: 12px" @click="moreModal.show = false"
          >取消</Button
        >
        <Button type="primary" @click="submitMorePay">提交</Button>
      </div>
    </Modal>

    <Modal
      :mask-closable="false"
      :closable="true"
      v-model="modalAddPoint.show"
      width="320"
    >
      <p slot="header" class="modal-header">系统赠送</p>
      <Form label-position="right" :label-width="100">
        <FormItem label="玩家ID:">
          <span style="color:red;">{{ modalAddPoint.param.user_id }}</span>
        </FormItem>
        <FormItem label="玩家昵称:">
          <span>{{ modalAddPoint.param.name }}</span>
        </FormItem>
        <FormItem label="充值金额:">
          <span style="color:red;">{{ modalAddPoint.param.point }}</span>
        </FormItem>
        <FormItem label="操作备注:">
          <span>{{ modalAddPoint.param.reason }}</span>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="warning" @click="modalAddPoint.show = false">取消</Button>
        <Button type="success" @click="vipPaydata">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import transToReq from '@/api/trans'
export default {
  name: 'gift',
  data() {
    return {
      app_id: '',
      reasonList: [],
      formData: {
        user_id: '',
        point: '',
        reason: ''
      },
      moreModal: {
        show: false,
        form: {
          point: '',
          reason: '',
          lines: ''
        }
      },
      modalAddPoint: {
        show: false,
        param: {
          user_id: '',
          name: '',
          point: '',
          reason: ''
        }
      }
    }
  },
  methods: {
    // 获取充值备注类型
    getRechargeRemarkConfig() {
      transToReq('GetRechargeRemarkConfig', {
        recharge_type: '',
        page: 1,
        limit: 1000,
        appid: this.app_id
      }).then(res => {
        console.log(res)
      })
    },
    // 系统赠送
    givePay() {
      if (!this.formData.user_id) {
        this.$Message.error('请输入玩家ID')
        return
      }
      if (!this.formData.point) {
        this.$Message.error('请输入操作金额')
        return
      }
      if (!this.formData.reason) {
        this.$Message.error('充值备注类型')
        return
      }
      transToReq('ManagerPayCheck', {
        app_id: Number(this.app_id),
        user_id: Number(this.formData.user_id),
        point: Number(this.formData.point),
        reason: this.formData.reason
      }).then(res => {
        this.modalAddPoint.show = true
        this.modalAddPoint.param = res._param
      })
    },
    // 批量操作
    submitMorePay() {
      if (!this.moreModal.form.point) {
        this.$Message.error('请输入操作金额')
        return
      }
      if (!this.moreModal.form.reason) {
        this.$Message.error('充值备注类型')
        return
      }
      if (!this.moreModal.form.lines) {
        this.$Message.error('请输入玩家ID')
        return
      }
      const userIds = this.moreModal.form.lines.split('\n')
      if (userIds) {
        const reqs = []
        userIds.forEach(id => {
          reqs.push(
            transToReq('ManagerPayCheck', {
              app_id: Number(this.app_id),
              user_id: Number(id),
              point: Number(this.moreModal.form.point),
              reason: this.moreModal.form.reason
            })
          )
        })
        Promise.all(reqs).then(values => {
          values.forEach((res, index) => {
            const data = res._param
            const t = setTimeout(() => {
              transToReq('GivePay', {
                app_id: data.app_id,
                user_id: data.user_id,
                point: data.point,
                reason: data.reason
              }).then(res => {
                this.$Message.success(data.user_id + '-赠送成功', 2000)
                this.moreModal.show = false
                clearTimeout(t)
              })
            }, 2000 * index)
          })
          this.$emit('update')
        })
      }
    },
    vipPaydata() {
      transToReq('GivePay', {
        app_id: Number(this.app_id),
        user_id: Number(this.formData.user_id),
        point: Number(this.formData.point),
        reason: this.formData.reason
      }).then(res => {
        this.$Message.success('赠送成功', 2000)
        this.modalAddPoint.show = false
        this.$emit('update')
      })
    }
  },
  activated() {
    this.app_id = this.app_list.find(
      el => el.platform == Number(localStorage.getItem('platId'))
    )['appid']
    // this.getRechargeRemarkConfig()
  }
}
</script>
